<template>
    <div class="container mx-auto">
        <div class="flex flex-wrap" v-if="discounts.length > 0">
            <div class="md:w-full pr-4 pl-4 mb-4">
                <div class="relative flex flex-col min-w-0 rounded break-words border-gray-400 border-1 border-gray-700">
                    <div class="py-3 px-6 mb-0 border-b-1 border-gray-400 text-white"><i class="fa fa-money"></i>  {{transEdit('discounts')}}</div>
                    <div class="flex-auto p-6">
                        <template v-for="discount in discounts">
                            <div class="text-gray-500">Vid köp {{discount.is_coupon_limit == '1' ? 'av' : 'för minst'}}
                                <span class="font-bold" :class="activeDiscount(discount) ? 'text-blue-500' : 'text-gray-500'">{{ discount.amount }}</span> {{discount.treatment.name}}
                                <template class="text-gray-500" v-if="discount.is_coupon_limit == '1'">kuponger</template>
                                <template v-else>kronor</template>
                                får du <span class="font-bold" :class="activeDiscount(discount) ? 'text-blue-500' : 'text-gray-500'">{{discount.discount_amount}}{{getDiscountType(discount)}} </span>
                                <template v-if="activeDiscount(discount)"><i id="discountCheck" class="fa fa-check absolute" aria-hidden="true"></i></template>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap pb-10">
            <div class="md:w-1/2 pr-4">
                <div class="flex flex-col rounded-lg text-white presale-bg">
                    <div class="py-3 px-6 mb-0 border-b-1 border-gray-400 text-white"><i class="fa fa-calendar"></i> Förköp av kuponger</div>
                    <div class="flex-auto p-6">
                        <form v-on:submit="addToCart" v-if="treatmentList.length > 0">
                            <div class="mb-4 ">
                                <label>Välj behandling</label>
                                <select class="block appearance-none w-full py-1 px-2 mb-1 text-base leading-normal text-white border border-gray-500 rounded presale-bg"
                                        v-model="treatment"
                                        name="treatment_id"
                                        id="treatment_id">
                                    <option v-for="treatment in treatments" :value="treatment.id">{{treatment.name}}
                                    </option>
                                </select>
                            </div>
                            <button class="inline-block align-middle text-center select-none border-gray-400 font-normal whitespace-no-wrap py-2 px-4 rounded text-base leading-normal text-whilte bg-primary" type="submit"><i class="fa fa-plus"></i> Lägg till</button>
                        </form>
                        <div v-else>Det finns inga prisbelagda behandlingar att köpa.</div>
                    </div>
                </div>
            </div>
            <div class="md:w-1/2 pl-4">
                <div class="flex flex-col rounded-lg text-white presale-bg">
                    <div class="py-3 px-6 mb-0 border-b-1 border-gray-400 text-white"><i class="fa fa-shopping-cart"></i> Kundvagn</div>
                    <div class="flex-auto p-6">
                        <ul class="flex flex-col pl-0 mb-0 bg-dark" v-if="cart.length > 0">
                            <li class="relative block py-3 border-b border-gray-100" v-for="(product, index) in cart">
                                <div class="flex justify-between align-center">
                                    <div class="flex justify-between items-center">
                                        <div class="relative inline-flex align-middle flex-col items-start justify-center productPrice">
                                            <button type="button" class="inline-block align-middle text-center select-none border rounded text-white border-primary hover:border-gray-400 text-sm leading-tight mb-1" @click="quantityChange(product, index, 'increment')" style="height: 30px; width: 30px;">+</button>
                                            <button type="button" class="inline-block align-middle text-center select-none border rounded text-white border-primary hover:border-gray-400 text-sm leading-tight" @click="quantityChange(product, index, 'decrement')" style="height: 30px; width: 30px;">-</button>
                                        </div>
                                        <div class="productPrice cartTotal">{{ product.quantity }}x</div>
                                        <div>{{ product.name }}</div>
                                    </div>
                                    <div class="flex justify-between align-center items-center">
                                        <div class="flex items-center productPrice">{{ numberFormat(getPriceIncVat(product) * product.quantity) }} kr</div>
                                        <button class="px-1 text-center select-none rounded text-white" @click="removeProduct(product, index)" style="background-size: cover; background-position: center center; height: 30px;"><i class="fa fa-times"></i></button>
                                    </div>
                                </div>
                            </li>
                            <li class="relative block py-3 px-6 -mb-px border border-r-0 border-l-0 border-gray-400" v-for="freeCoupon in freeCoupons">
                                <div class="flex justify-between align-center text-green-500">
                                    <div class="flex justify-between align-center"  style="margin-left: 9px;">
                                        <div class="relative inline-flex align-middle flex-col items-start justify-center productPrice">
                                        </div>
                                        <div class="flex items-center productPrice cartTotal">+ {{ freeCoupon.discount_amount }}</div>
                                        <div class="flex items-center">{{ freeCoupon.treatment.name }}</div>
                                    </div>
                                    <div class="flex justify-between align-center"  style="margin-right: 11px;">
                                        <div class="productPrice">0 kr</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <div class="flex my-2" v-if="checkoutBool">
                            <div class="flex flex-col flex-1">
                                <div class="flex justify-between"><div class="pr-1">Summa:</div> <div>{{ numberFormat(cartSubTotal) }} kr</div></div>
                                <div class="flex justify-between"><div class="pr-1">Moms:</div> <div>{{ numberFormat(cartVatTotal) }} kr</div></div>
                                <div v-if="discountAmount > 0" class="flex justify-between">
                                    <div class="pr-1 text-green-500">Rabatt:</div> <div class="text-green-500">{{ numberFormat(discountAmount) }} kr</div>
                                </div>
                                <div class="flex justify-between font-bold"><div class="pr-1">Totalt:</div> <div>{{ numberFormat(cartTotal - discountAmount) }} kr</div></div>


                                <div v-if="customer && customer.company.wellness_provider_id == 2 && !customer.is_consultant" class="border border-white rounded p-5 mt-6">
                                    <div class="flex flex-row justify-between ">
                                        <div>
                                            Tillgängligt bidrag:
                                        </div>
                                        <div class="text-right">
                                            {{ numberFormat(customer.wellness_contribution) }} kr
                                        </div>
                                    </div>

                                    <div class="flex flex-row justify-between ">
                                        <div>
                                            Avdrag från bidrag:
                                        </div>
                                        <div class="text-right">
                                            - {{ numberFormat(deduction) }} kr
                                        </div>
                                    </div>


                                    <div class="flex flex-row justify-between">
                                        <div>
                                            Beräknad nettokostnad:
                                        </div>
                                        <div class="text-right">
                                            {{ numberFormat(from_salary) }} kr
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="pt-2 flex" v-if="checkoutBool">
                            <button type="button" class="inline-block align-middle text-center select-none border font-normal whitespace-no-wrap py-2 px-4 rounded text-base leading-normal text-white border-gray-400 flex-1 mr-2" v-show="checkoutBool" @click="clearCart()">
                                <i class="fa fa-trash"></i> Töm varukorgen
                            </button>
                            <button type="button" class="inline-block align-middle text-center select-none border-gray-400 font-normal whitespace-no-wrap py-2 px-4 rounded text-base leading-normal text-white bg-primary flex-1" @click="propagateCheckout()">
                                <i class="fa fa-shopping-cart"></i> Till kassan
                            </button>
                        </div>
                        <div v-if="!checkoutBool">
                            Din kundvagn är tom.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Modal from './presaleCheckout'
    import reactiveDiscount from './reactiveDiscount'
    import Vue from 'vue';

    export default {
        name: "presaleCoupons",
        mixins: [reactiveDiscount],
        props: ["user_id", 'route_back', 'treatments', 'discounts', 'customer', 'subventions_left'],
        data() {
            return {
                cart: [],
                cartSubTotal: 0,
                cartVatTotal: 0,
                cartTotal: 0,
                checkoutBool: false,
                treatment: 1,
                couponTotal: 0,
                discountArr: this.discounts,
                currDiscount: [],
                discountAmount: [],
                freeCoupons: [],
                treatmentList: this.treatments,
                isModalVisible: false,
                fontSize: 1,
                preselectedDiscount: false,
            }
        },
        created() {
            let queryStr = window.location.href.substring(window.location.href.lastIndexOf("/") + 1, window.location.href.length);
            if(this.isNumeric(queryStr)) {
                this.preselectedDiscount = queryStr;
            }

        },

        computed: {
            deduction_remaining() {
                return this.customer.wellness_contribution - (this.cartTotal - this.discountAmount);
            },

            deduction() {
                let deduction = (this.cartTotal - this.discountAmount);

                if(this.deduction_remaining < 0) {
                    deduction = this.customer.wellness_contribution;
                }

                return deduction;
            },

            from_salary() {
                let from_salary = 0;

                if(this.deduction_remaining < 0) {
                    from_salary = this.deduction - (this.cartTotal - this.discountAmount);
                }

                return from_salary;
            },

            hasSubventions() {
                return this.subventions_left == null ? false : true;
            }
        },


        methods: {
            numberFormat(val) {
                return window.number_format(val);
            },
            isNumeric(str) {
                return !isNaN(str - parseFloat(str));
            },
            getPriceIncVat (product) {
                let vatInDecimals = product.vat / 100;

                return (this.subventions_left ? product.prices[0].subv_price : (product.prices[0].full_price * (1 + vatInDecimals)));
            },
            addToCart: function(e = null) {
                if (e) e.preventDefault();
                let found = false;
                let product = this.treatmentList.filter((product) => {
                    return product.id == this.treatment;
                });
                product = product[0];

                for (let i = 0; i < this.cart.length; i++) {
                    if (this.cart[i].id === product.id) {
                        let newProduct = this.cart[i];
                        newProduct.quantity = newProduct.quantity + 1;
                        Vue.set(this.cart, i, newProduct);
                        found = true;
                        break;
                    }
                }
                this.couponTotal = this.couponTotal + 1;
                if(!found) {
                    product.quantity = 1;
                    this.cart.push(product);
                }

                this.setCheckoutBool();
            },
            removeProduct: function(product, index) {
                this.couponTotal -= product.quantity;
                this.cart.splice(index, 1);

                this.setCheckoutBool();
            },
            clearCart: function() {
                this.cart = [];
                this.cartSubTotal = 0;
                this.cartVatTotal = 0;
                this.cartTotal = 0;
                this.checkoutBool = false;
                this.showCart = false;
                this.couponTotal = 0;
            },
            quantityChange: function(product, index, direction) {
                for (let i = 0; i < this.cart.length; i++) {
                    if (this.cart[i].id === product.id) {

                        let newProduct = this.cart[i];

                        if(direction === "increment") {
                            if(this.hasSubventions && newProduct.quantity >= this.subventions_left) {
                                alert(`Du kan köpa max ${this.subventions_left} behandlingar till detta pris.`);
                                return;
                            }
                            newProduct.quantity = newProduct.quantity + 1;
                            this.couponTotal += 1;
                            Vue.set(this.cart, i, newProduct);
                        } else {
                            newProduct.quantity = newProduct.quantity - 1;
                            this.couponTotal -= 1;
                            if(newProduct.quantity == 0) {
                                this.cart.splice(index, 1);
                            } else {
                                Vue.set(this.cart, i, newProduct);
                            }
                        }
                    }
                }
                this.setCheckoutBool();
            },
            showModal() {
                this.$modal.show(Modal, {
                    'cart': this.cart,
                    'has_subventions': this.hasSubventions,
                    'subventions_left': this.subventions_left,
                }, {
                    'width': '100%',
                    'max-width': 600,
                    'adaptive': true,
                    'height': 'auto',
                    'clickToClose': false,
                });
            },
            setCheckoutBool() {
                this.checkoutBool = this.cart.length > 0;
            },
            propagateCheckout: function() {
                this.cart.cartVatTotal = this.cartVatTotal;
                this.cart.cartSubTotal = this.cartSubTotal;
                this.cart.cartTotal = this.cartTotal;
                this.cart.currDiscount = this.currDiscount;
                this.cart.discountAmount = this.discountAmount;
                this.cart.freeCoupons = this.freeCoupons;
                this.$eventHub.$emit('coupon-checkout', this.cart);
                this.showModal();
            },
            round2Digits(number) {
                return Math.round( Math.round( number * 1000 ) / 10 ) / 100;
            }
        },
        watch: {
            preselectedDiscount: function (val, oldValue) {
                let discount = this.discounts.filter((discount) => {
                    return discount.id == val;
                })[0];
                let product = this.treatmentList.filter((product) => {
                    return product.id == discount.treatment.id;
                })[0];

                if(discount.is_coupon_limit) {
                    product.quantity = discount.amount;
                    Vue.set(this.cart, 0, product);
                    this.couponTotal = discount.amount;

                    this.setCheckoutBool();
                }
            }
        },
        route_back: function () {
            return this.route_back;
        }
    }
</script>

<style scoped>
    .cartSubTotal {
        font-size: 1em;
    }
    .cartTotal {
        font-size: 1.25em;
    }
    .back_button {
        margin-bottom: 15px;
    }
    .productPrice {
        margin-right: 5px;
    }
    #discountCheck {
        color: #1d933c;
        text-shadow: 1px 1px 1px #2ab27b;
        font-size: 1.5em;
    }
    .discount_text {
        font-size: 22px;
        color: #45AEC7;
        font-weight: bold;
    }

    .list-group-item {
        background: 0;
    }
    .btn-outline-info {
        border-color: #45AEC7 !important;
    }

    .presale-bg {
        background-color: rgba(38, 38, 38, 0.7);
    }
</style>
